import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Subject } from 'rxjs';
import { ServiceTicketStore } from '../../../../../@store';
import { CommonStandaloneModule } from '../../../../common-standalone.module';
import { ServiceTicketArticlesListComponent } from '../service-ticket-articles-list/service-ticket-articles-list.component';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-service-ticket-extra-information',
  standalone: true,
  imports: [
    CommonStandaloneModule,
    ServiceTicketArticlesListComponent,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './service-ticket-extra-information.component.html',
  styleUrls: ['./service-ticket-extra-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceTicketExtraInformationComponent implements OnInit, OnDestroy {
  boilerSerial: string;
  private ngUnsubscribe$ = new Subject<void>();

  constructor(private serviceTicketStore: ServiceTicketStore) {}

  ngOnInit(): void {
    this.serviceTicketStore.requestRoutingProviderPayloadBoilerSerial$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((requestRoutingProviderPayloadBoilerSerial) => {
        this.boilerSerial = requestRoutingProviderPayloadBoilerSerial;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  onCallNowClicked(): void {
    if (this.boilerSerial) {
      this.serviceTicketStore.requestRoutingProvider(this.boilerSerial);
    }
    this.serviceTicketStore.openCallPage();
  }
}
